// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { mediaQueries } from "../../utils/theme/media-queries"
import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Charlotte = ({ name, position, paragraph }) => {
  const data = useStaticQuery(graphql`
    query CharlotteClientQuery {
      CharloteImg: file(relativePath: { eq: "Charlotte.png" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fixed(width: 125, height: 125, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  return (
    <div
      sx={{
        marginTop: `2rem`,
        [mediaQueries.lg]: {
          marginTop: `10rem`,
        },
      }}
    >
      <div sx={{ display: `flex`, margin: `auto` }}>
        <div
          sx={{
            display: `flex`,
            flexDirection: `column`,
            border: `1px solid`,
            borderColor: `#e3e3e3`,
            borderRadius: `20px`,
            paddingBottom: `1rem`,
            backgroundColor: colors.white,
          }}
        >
          <div
            sx={{
              position: `absolute`,
              width: `7.8rem`,
              right: [`34%`, `39%`, `79%`, `75%`],
              top: [`77%`, `77%`, `54%`, `55%`],
            }}
          >
            <Img fixed={data.CharloteImg.childImageSharp.fixed} alt="" />
          </div>
          <h3
            sx={{
              paddingTop: `4rem`,
              alignSelf: `center`,
              fontWeight: fontWeights.semiBold,
              color: colors.code.secondary,
              textTransform: `uppercase`,
              lineHeight: `1.2`,
              letterSpacing: `1.5px`,
              fontSize: `0.938rem`,
            }}
          >
            {name}
          </h3>
          <h3
            sx={{
              alignSelf: `center`,
              fontSize: `0.9rem`,
              lineHeight: `1.2`,
              opacity: `0.6`,
              fontWeight: fontWeights.body,
            }}
          >
            {position}
          </h3>
          <hr
            sx={{
              border: `2px solid `,
              borderColor: colors.code.primary,
              color: colors.code.primary,
              width: `1.9rem`,
              alignSelf: `center`,
            }}
          />
          <p
            sx={{
              marginLeft: `0.2rem`,
              marginRight: `0.2rem`,
              alignSelf: `center`,
              textAlign: `center`,
              fontSize: `0.9rem`,
              [mediaQueries.lg]: {
                marginLeft: `3.5rem`,
                marginRight: `3.5rem`,
              },
            }}
          >
            {paragraph}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Charlotte
